<template>
    <div style="text-align: center;">
        UseRecord
    </div>
</template>

<script>
    export default {
        name: "UseRecord",
    };
</script>

<style>

</style>